import React from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { AppButton } from 'apps/promo/components/common/app-button/AppButton';
import { BlogTile } from 'apps/promo/components/common/blog-tile/BlogTile';
import ColoredSectionContainer from 'apps/promo/components/common/ColoredSectionContainer';
import PromoButtonExtended from 'apps/promo/components/common/promo-button/PromoButtonExtended';
import { PromoCountriesColumns } from 'apps/promo/components/common/promo-countries/PromoCountriesColumns';
import PromoCountryItemPlain from 'apps/promo/components/common/promo-countries/PromoCountryItemPlain';
import { PromoDangerouslyHtml } from 'apps/promo/components/common/promo-dangerously-html/PromoDangerouslyHtml';
import { PromoPageContainer } from 'apps/promo/components/common/promo-page-container/PromoPageContainer';
import { PromoRow } from 'apps/promo/components/common/PromoRow/PromoRow';
import FaqSection from 'apps/promo/components/common/sections/FaqSection';
import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import { HeroSection } from 'apps/promo/components/common/sections/HeroSection';
import { ListingTilesSection } from 'apps/promo/components/common/sections/ListingTilesSection';
import { TilesSection } from 'apps/promo/components/common/sections/TilesSection';
import TrustpilotSection from 'apps/promo/components/common/sections/TrustpilotSection';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';
import { getLangCountryPrefix } from 'apps/promo/helpers/utils';
import promoMedia from 'apps/promo/theme/promoMedia';

const BtnContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    column-gap: 16px;
    padding: 16px 0;

    ${promoMedia.desktop1440} {
        column-gap: 96px;
        padding: 32px 0;
    }
`;
const BlogTiles = styled.div`
    margin-left: -10px;
    margin-right: -10px;
`;

const Logos = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 16px;
    flex-wrap: wrap;

    ${promoMedia.tablet744} {
        flex-direction: row;
    }
`;
const LogoContainer = styled.div`
    width: 100%;
    text-align: center;
    box-sizing: border-box;

    ${promoMedia.tablet744} {
        width: 50%;
    }

    ${promoMedia.desktop1440} {
        width: 25%;
        padding: 0 16px;
    }
`;

const UvnPage = (props) => {
    const countryPrefix = `${getLangCountryPrefix(props.lang, props.country)}`;

    return (
        <PromoPageContainer bgColor="eggshell03" noIndent hasTopPadding>
            <BtnContainer>
                <AppButton href={props.apple_store} variant="apple" areaLabel="App Store" esLang />
                <AppButton href={props.google_play} variant="google" areaLabel="Google Play" esLang />
            </BtnContainer>

            <ColoredSectionContainer noTopPadding>
                {props.headline1Title && <HeadingSection title={props.headline1Title} titleVariant={'h3'} noBottomIndent noTopIndent />}
            </ColoredSectionContainer>

            {props.heroTitle && (
                <HeroSection
                    title={props.heroTitle}
                    text={props.heroText}
                    bgImg={props.heroBgImg}
                    img={props.heroImg}
                    data={props.heroData}
                    btnVariant={'primary'}
                    isInvertedBtn
                    noIconBtn
                />
            )}

            <ColoredSectionContainer noTopPadding>
                {props.headline2Title && <HeadingSection titleVariant={'h3'} title={props.headline2Title} noBottomIndent />}
                {props.listing_cards && <ListingTilesSection data={props.listing_cards} />}
                {props.headline3Title && <HeadingSection titleVariant={'h3'} title={props.headline3Title} noBottomIndent />}
            </ColoredSectionContainer>

            {props.hero2Title && (
                <HeroSection
                    title={props.hero2Title}
                    text={props.hero2Text}
                    bgImg={props.hero2BgImg}
                    img={props.hero2Img}
                    data={props.hero2Data}
                    btnVariant={'primary'}
                    isInvertedBtn
                    noIconBtn
                    horizontalLayout
                />
            )}

            <BtnContainer>
                <AppButton href={props.apple_store} variant="apple" areaLabel="App Store" esLang />
                <AppButton href={props.google_play} variant="google" areaLabel="Google Play" esLang />
            </BtnContainer>

            <ColoredSectionContainer noTopPadding>
                {props.headline4Title && <HeadingSection titleVariant={'h3'} title={props.headline4Title} noBottomIndent />}
                {props.listingCards2 && <ListingTilesSection data={props.listingCards2} />}

                {props.lang && <TrustpilotSection lang={props.lang} isMiniWidget />}

                <BtnContainer>
                    <AppButton href={props.apple_store} variant="apple" areaLabel="App Store" esLang />
                    <AppButton href={props.google_play} variant="google" areaLabel="Google Play" esLang />
                </BtnContainer>

                {props.headline5Title && <HeadingSection titleVariant={'h3'} title={props.headline5Title} noBottomIndent />}
                {props.articles.data && (
                    <BlogTiles>
                        <PromoRow indent="adaptive-24-32">
                            {Array.isArray(props.articles.data) &&
                                props.articles.data
                                    .filter((item, index) => item !== null && index < 2)
                                    .map((item) => {
                                        return (
                                            <BlogTile
                                                key={item.id}
                                                date={item.date}
                                                location={item.location}
                                                text={item.preview_text}
                                                categories={item.categories}
                                                title={item.title}
                                                img={item.img}
                                                link={`${countryPrefix}/blog/${item.slug}`}
                                            />
                                        );
                                    })}
                        </PromoRow>
                    </BlogTiles>
                )}
                {props.headline5Btn && (
                    <PromoRow textAlign={'center'} indent="adaptive-24-32">
                        <PromoButtonExtended
                            btn={props.headline5Btn}
                            variant={'primary'}
                            hasLangCountry={props.headline5BtnLangCountry}
                            lang={props.lang}
                            country={props.country}
                        />
                    </PromoRow>
                )}
            </ColoredSectionContainer>

            {props.headline6Title && (
                <ColoredSectionContainer bgColor="purple5" noTopPadding bottomPadding>
                    <HeadingSection titleVariant={'h3'} title={props.headline6Title} text={props.headline6Text} noBottomIndent />
                    <Logos>
                        {Array.isArray(props.logos) &&
                            props.logos
                                .filter((item) => item !== null)
                                .map((item) => {
                                    return (
                                        <LogoContainer key={item.id}>
                                            <img src={item.url} alt={item.name} />
                                        </LogoContainer>
                                    );
                                })}
                    </Logos>
                </ColoredSectionContainer>
            )}

            <ColoredSectionContainer noTopPadding>
                {props.headline7Title && <HeadingSection titleVariant={'h3'} title={props.headline7Title} noBottomIndent />}

                {props.uvnCountries && (
                    <PromoCountriesColumns>
                        {Array.isArray(props.uvnCountries) &&
                            props.uvnCountries
                                .filter((item) => item !== null)
                                .map((item) => {
                                    return (
                                        <PromoCountryItemPlain
                                            key={item.id}
                                            href={`${countryPrefix}${item.url}`}
                                            flagName={item.countryCode}
                                            countryName={item.countryName}
                                        />
                                    );
                                })}
                    </PromoCountriesColumns>
                )}

                {props.headline7Btn && (
                    <PromoRow textAlign={'center'} indent="adaptive-8-12">
                        <PromoButtonExtended
                            btn={props.headline7Btn}
                            variant={'primary'}
                            hasLangCountry={props.headline7BtnLangCountry}
                            lang={props.lang}
                            country={props.country}
                        />
                    </PromoRow>
                )}

                <BtnContainer>
                    <AppButton href={props.apple_store} variant="apple" areaLabel="App Store" esLang />
                    <AppButton href={props.google_play} variant="google" areaLabel="Google Play" esLang />
                </BtnContainer>
            </ColoredSectionContainer>

            {props.faqTitle && props.questions && <FaqSection title={props.faqTitle} questions={props.questions} bgColor={'transparent'} />}

            <ColoredSectionContainer bgColor="purple5" noTopPadding bottomPadding>
                {props.headline8Title && <HeadingSection titleVariant={'h3'} title={props.headline8Title} noBottomIndent />}
                {props.tiles && <TilesSection data={props.tiles} lang={props.lang} country={props.country} loadingLazy />}
                {props.headline9Text && <PromoDangerouslyHtml dangerouslyHtml={props.headline9Text} color={'gray80'} variant={'note'} />}
            </ColoredSectionContainer>
        </PromoPageContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        headline1Title: state.extra?.strapiApi?.headline_1?.title,

        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroData: state.extra?.strapiApi?.hero_block,
        heroBgImg: state.extra?.strapiApi?.hero_block?.bgImg,
        heroImg: state.extra?.strapiApi?.hero_block?.img,

        headline2Title: state.extra?.strapiApi?.headline_2?.title,

        listing_cards: state.extra?.strapiApi?.listing_cards,

        headline3Title: state.extra?.strapiApi?.headline_3?.title,

        hero2Title: state.extra?.strapiApi?.hero_block_2?.title,
        hero2Text: state.extra?.strapiApi?.hero_block_2?.text,
        hero2Data: state.extra?.strapiApi?.hero_block_2,
        hero2BgImg: state.extra?.strapiApi?.hero_block_2?.bgImg,
        hero2Img: state.extra?.strapiApi?.hero_block_2?.img,

        headline4Title: state.extra?.strapiApi?.headline_4?.title,

        listingCards2: state.extra?.strapiApi?.listing_cards_2,

        headline5Title: state.extra?.strapiApi?.headline_5?.title,
        headline5Btn: state.extra?.strapiApi?.headline_5?.btn,
        headline5BtnLangCountry: state.extra?.strapiApi?.headline_5?.add_country_lang_inside_link,
        articles: state.extra?.strapiApi?.articles,

        headline6Title: state.extra?.strapiApi?.headline_6?.title,
        headline6Text: state.extra?.strapiApi?.headline_6?.text,
        logos: state.extra?.strapiApi?.logos,

        headline7Title: state.extra?.strapiApi?.headline_7?.title,
        headline7Btn: state.extra?.strapiApi?.headline_7?.btn,
        headline7BtnLangCountry: state.extra?.strapiApi?.headline_7?.add_country_lang_inside_link,
        uvnCountries: state.extra?.strapiApi?.uvn_countries,

        faqTitle: state.extra?.strapiApi?.faq?.title,
        questions: state.extra?.strapiApi?.faq?.questions,

        headline8Title: state.extra?.strapiApi?.headline_8?.title,
        tiles: state.extra?.strapiApi?.tiles_section,

        headline9Text: state.extra?.strapiApi?.headline_9?.text,

        apple_store: state.extra?.strapiApi?.link_to_appstore,
        google_play: state.extra?.strapiApi?.link_to_googleplay,

        lang: state.extra.noAuthFooter?.language?.lang,
        country: state.extra.noAuthFooter?.language?.country,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(UvnPage));
